import React from "react";
import Button from "@mui/material/Button";
import { Icon } from "__ICON_REFERENCE__";
import styles from "./techIssueAlert.module.scss";
import { withLocalizer } from "utilities/withLocalizer";

function TechIssueAlert(props) {

    const { isShow, onCancel } = props;

    return (
        <div className={styles.modal}>
            <div className={isShow ? "show" : "hide"}>

                <div className="popup-container-bg"></div>

                <div className="popup-container">

                    <div className="popup-container-border">

                        <span data-testid="close-button" onClick={() => onCancel()}>
                            <Icon name="close--n" className="icon" />
                        </span>

                        <div className="popup-heading margin-bottom-1x">
                            {props.localizeByLang("qma-tech-issue-title", "en")}
                        </div>

                        <div className="popup margin-bottom-1x">
                            {props.localizeByLang("qma-tech-issue-tip", "en")}
                        </div>

                    </div>

                </div>

            </div>
        </div>

    );
}

export default withLocalizer(TechIssueAlert);